import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { DestinationSearchParams } from './params/destination-search.params';
import { Observable } from 'rxjs';
import { DestinationResponse } from './responses/destination.response';
import { PaginatedResponse } from '../../../shared/models/paginated-response';
import { TransferStatisticsResponse } from './responses/transfer-statistics.response';
import { ImportProgressResponse } from './responses/import-progress.response';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class DestinationService {
    constructor(private http: HttpClient) {}

    index(
        params: DestinationSearchParams = {}
    ): Observable<PaginatedResponse<DestinationResponse>> {
        const defaultParams = {
            page: 1,
            limit: 25,
        };
        params = { ...defaultParams, ...params };

        return this.http.get<PaginatedResponse<DestinationResponse>>(
            `${environment.urls.service}/api/v1/authenticated/admin/bot/destination`,
            { params: params as any }
        );
    }

    show(destinationId: string): Observable<DestinationResponse> {
        return this.http.get<DestinationResponse>(
            `${environment.urls.service}/api/v1/authenticated/admin/bot/destination/${destinationId}`
        );
    }

    startPrepare(destinationId: string): Observable<void> {
        return this.http.post<void>(
            `${environment.urls.service}/api/v1/authenticated/admin/bot/destination/${destinationId}/start-prepare`,
            {}
        );
    }

    stopPrepare(destinationId: string): Observable<void> {
        return this.http.post<void>(
            `${environment.urls.service}/api/v1/authenticated/admin/bot/destination/${destinationId}/stop-prepare`,
            {}
        );
    }

    statistics(destinationId: string): Observable<TransferStatisticsResponse> {
        return this.http.get<TransferStatisticsResponse>(
            `${environment.urls.service}/api/v1/authenticated/admin/bot/destination/${destinationId}/transfer-statistics`
        );
    }

    importStatistics(
        destinationId: string
    ): Observable<IBotTransferFinishedStatistics> {
        return this.http
            .get<any>(
                `${environment.urls.service}/api/v1/authenticated/admin/bot/destination/${destinationId}/import/statistics`
            )
            .pipe(map((res) => res.statistics));
    }

    downloadHousingData(destinationId: string): Observable<Blob> {
        return this.http.get(
            `${environment.urls.service}/api/v1/authenticated/admin/bot/destination/${destinationId}/import/download-housing-data`,
            { responseType: 'blob' }
        );
    }

    startImport(destinationId: string): Observable<void> {
        return this.http.post<void>(
            `${environment.urls.service}/api/v1/authenticated/admin/bot/destination/${destinationId}/import/start`,
            {}
        );
    }

    importProgress(destinationId: string): Observable<ImportProgressResponse> {
        return this.http.get<ImportProgressResponse>(
            `${environment.urls.service}/api/v1/authenticated/admin/bot/destination/${destinationId}/import/import-progress`
        );
    }
}
